<template>
  <div class="view-home py-5 container">
    <action-dispatcher action="courses/getLastLessons">
      <h1 v-if="lastLessons.length" class="text-center my-3">
        Continue de onde parou...
      </h1>

      <div class="row">
        <div
          v-for="(lesson, i) in progressCourses"
          :key="i"
          class="col-xl-4 col-md-6 mb-4 d-flex"
        >
          <progress-course-card class="flex-fill" :lesson="lesson" />
        </div>
      </div>
    </action-dispatcher>

    <h1 class="text-center my-4">Meus Cursos</h1>

    <div class="row">
      <div
        v-for="(course, i) in $user.courses"
        :key="i"
        class="col-lg-4 col-md-6 mb-4 d-flex"
      >
        <course-card class="flex-fill" :course="course" />
      </div>
    </div>

    <h1 class="text-center my-4">Outros Cursos</h1>

    <action-dispatcher action="courses/getAll">
      <div class="row">
        <template v-for="(course, i) in notMyCourses">
          <div
            v-if="!course.is_unlisted"
            class="col-lg-4 col-md-6 mb-4 d-flex"
            :key="i"
          >
            <course-card class="flex-fill" :course="course" external-link />
          </div>
        </template>
      </div>
    </action-dispatcher>
  </div>
</template>

<script>
import CourseCard from "@/components/home/CourseCard";
import ProgressCourseCard from "@/components/home/ProgressCourseCard";
import { mapState } from "vuex";

export default {
  components: { CourseCard, ProgressCourseCard },
  computed: {
    ...mapState("courses", ["lastLessons", "courses"]),
    progressCourses() {
      return this.lastLessons.slice(0, 3);
    },
    notMyCourses() {
      return this.courses.filter(course => {
        return !this.$user.courses.find(myCourse => myCourse.id === course.id);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  .cover {
    border-radius: 16px;
    width: 100%;
  }
}
</style>
